import { Logger, EventEmitter } from 'vue-infra';
import { NAMESPACE } from '@/common/consts';

/**
 * Basic Logic Component.
 */
class BaseClass extends EventEmitter {
  /**
   * @type {Logger}
   */
  get logger() {
    return Logger.getLogger(`${this.$name}`);
  }
  constructor(config) {
    super();
    this.$name = `${config.type || 'Generic'}<${config.name}>`;
    this.logger.debug('Component Created', '*Component', this);
  }

  // TODO: how do we use this later?
  throwError({
    graphName, message, error,
  }) {
    if (graphName) {
      this.logger.graph({ name: `ERR_${this.$name}_${graphName}` });
    }
    if (error) {
      throw error;
    } else if (message) {
      this.logError(message);
      throw new Error(message);
    }
  }

  logError(message) {
    this.logger.error('ERROR:', `${NAMESPACE.IHUB}: app.js`, message);
  }
}

export default BaseClass;
